<div class="card border-0">
    <div class="card-header">
        <div class="card-title">{{ title }}</div>
    </div>
    <div class="container-consultas">
        <div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 col-print-6">
                    <div class="subtitle">
                        DADOS CADASTRAIS
                    </div>
                    <div class="d-flex d-print-flex py-2">
                        <div class="row col-12 px-2">
                            <div class="col-12 col-sm-12 col-print-7 py-lg-1">
                                <div class="text-secondary f-12 format-compacta">NOME COMPLETO:</div>
                                <div class="text-uppercase format-compacta">{{ resumoCredito.nome || 'NADA CONSTA'}}</div>
                            </div>
                            <div class="col-12 col-sm-12 col-print-7 py-lg-1">
                                <div class="text-secondary f-12 format-compacta">CPF/CNPJ:</div>
                                <div class="text-uppercase format-compacta">{{ resumoCredito.cpf_cnpj || 'NADA CONSTA'}}</div>
                            </div>
                            <div class="col-12 col-sm-12 col-print-7 py-lg-1">
                                <div class="text-secondary f-12 format-compacta">ENDEREÇO:</div>
                                <div class="text-uppercase format-compacta">{{ resumoCredito.endereco || 'NADA CONSTA'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <ng-container>
                    <div class="col-12 col-md-6 col-lg-6 col-print-6">
                        <div class="subtitle">
                            DADOS CONSULTA
                        </div>
                        <div class="d-flex d-print-flex py-2">
                            <div class="row col-12 px-2">
                                <div class="col-6 col-sm-6 col-print-7 py-lg-1">
                                    <div class="text-secondary f-12 format-compacta">SOLICITATO POR:</div>
                                    <div class="text-uppercase format-compacta">{{ resumoCredito?.unidade || 'NADA CONSTA'}}</div>
                                </div>
                                <div class="col-6 col-sm-6 col-print-7 py-lg-1">
                                    <div class="text-secondary f-12 format-compacta">DATA REALIZAÇÃO:</div>
                                    <div class="text-uppercase format-compacta">{{ resumoCredito?.data_criacao || 'NADA CONSTA'}}</div>
                                </div>
                                <div class="col-6 col-sm-6 col-print-7 py-lg-1">
                                    <div class="text-secondary f-12 format-compacta">USUÁRIO:</div>
                                    <div class="text-uppercase format-compacta">{{ resumoCredito?.usuario || 'NADA CONSTA'}}</div>
                                </div>
                                <div class="col-6 col-sm-6 col-print-7 py-lg-1">
                                    <div class="text-secondary f-12 format-compacta">CÓDIGO CONSULTA:</div>
                                    <div class="text-uppercase format-compacta">{{ resumoCredito?.codigo_consulta || 'NADA CONSTA'}}</div>
                                </div>
                                <div class="col-12 col-sm-12 col-print-7 py-lg-1">
                                    <div class="text-secondary f-12 format-compacta">TOKEN DA CONSULTA:</div>
                                    <div class="text-uppercase format-compacta">{{ resumoCredito?.tokenConsulta || 'NADA CONSTA'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 col-print-12">
                    <app-alertas [alerts]="alerts"></app-alertas>
                </div>
            </div>
        </div>
    </div>
</div>